import { PRODUCT_TYPE } from '../../../../constants/constant.content'
import { FundRuleName } from './fund-rule-name'
import { IFundRule } from './ifund-rule'

export class ConsolidatedCustomRules implements IFundRule {
  ruleName: FundRuleName
  private ruleClassificationMap: Map<string, IFundRule[]> = new Map<
    string,
    IFundRule[]
  >()
  private productType = PRODUCT_TYPE
  private ruleGroupMap: Map<FundRuleName, string> = new Map<
    FundRuleName,
    string
  >()

  constructor(ruleAry: IFundRule[]) {
    this.initRuleMapGroup()
    this.segregateRules(ruleAry)
  }

  private initRuleMapGroup() {
    this.ruleGroupMap.set(
      FundRuleName.PRODUCT_TYPE_MUTUAL_FUND,
      this.productType,
    )
    this.ruleGroupMap.set(FundRuleName.PRODUCT_TYPE_ETF, this.productType)
    this.ruleGroupMap.set(
      FundRuleName.PRODUCT_TYPE_COLLECTIVE_TRUST,
      this.productType,
    )
  }

  private segregateRules(ruleAry: IFundRule[]) {
    ruleAry.forEach((rule: IFundRule) => {
      const groupName: string = this.ruleGroupMap.get(rule.ruleName)

      if (!this.ruleClassificationMap.get(groupName)) {
        this.ruleClassificationMap.set(groupName, <IFundRule[]>[])
      }
      this.ruleClassificationMap.get(groupName).push(rule)
    })
  }

  isRuleApplicable(fund: any): boolean {
    let isFundValidated = true

    this.ruleClassificationMap.forEach((ruleAry: IFundRule[]) => {
      let rule: IFundRule,
        isRuleAppliedForGroup = false
      for (rule of ruleAry) {
        if (rule.isRuleApplicable(fund)) {
          isRuleAppliedForGroup = true
          break
        }
      }
      isFundValidated = isFundValidated && isRuleAppliedForGroup
    })
    return isFundValidated
  }
}
